import { makeStyles } from '@material-ui/core'

const useStyle = makeStyles(() => {
  return {
    asakaibrowser: {
      marginTop: '8px',
    },
    counter: {
      fontSize: '17px',
      marginTop: '8px',
    },
    nextButton: {
      color: 'white',
    },
  }
})

export default useStyle
